const URL = process.env.NODE_ENV === 'production' ? 'https://yourdomain/' : 'http://118.25.47.128:8881';
export default URL;